(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react')) :
  typeof define === 'function' && define.amd ? define('@fdn/button_campaign', ['react'], factory) :
  (global = global || self, global['@fdn/button_campaign'] = factory(global.React));
}(this, (function (React) { 'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;

  var Desktop = function Desktop(props) {
    return /*#__PURE__*/React.createElement("div", {
      id: props.element_id,
      className: "campaign-button-wrapper"
    }, /*#__PURE__*/React.createElement("button", {
      className: "close-campaign",
      onClick: function onClick() {
        return props.show_campaign(false);
      }
    }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null)), /*#__PURE__*/React.createElement("a", {
      href: props.campaign_link,
      target: "_blank"
    }, /*#__PURE__*/React.createElement("img", {
      src: props.button_image,
      className: "campaign-button"
    })), /*#__PURE__*/React.createElement("style", null, "\n          .campaign-button-wrapper {\n            position: fixed;\n            text-align: right;\n            bottom: 5vh;\n            z-index: 3;\n            right: 6vw;\n            transition: all .4s ease-in;\n          }\n\n          .campaign-button-wrapper a {\n            display: inline-block;\n          }\n\n          .close-campaign {\n            width: 30px;\n            height: 30px;\n            position: absolute;\n            border-radius: 50%;\n            background-color: ".concat(props.close_bg_color, ";\n            top: 0;\n            right: 0;\n            border: none;\n          }\n\n          .close-campaign span {\n            width: 20px;\n            height: 2px;\n            border-radius: 8px;\n            display: block;\n            background-color: ").concat(props.close_arrow_color, ";\n            position: absolute;\n            top: 47.5%;\n            left: 5px;\n          }\n\n          .close-campaign span:nth-child(1) {\n            transform: rotate(45deg);\n          }\n\n          .close-campaign span:nth-child(2) {\n            transform: rotate(-45deg);\n          }\n\n          .campaign-button {\n            max-width: 100%;\n            display: block;\n            margin-left: auto;\n            width: 150px;\n          }\n\n          @media(max-width: 1440px) {\n            .campaign-button-wrapper{\n              right: 10vw;\n            }\n          }\n\n          @media(max-width: 1366px) {\n            .campaign-button-wrapper {\n              right: 8vw;\n            }\n          }\n        ")));
  };

  var Mobile = function Mobile(props) {
    return /*#__PURE__*/React.createElement("div", {
      id: props.element_id,
      className: "campaign-button-wrapper"
    }, /*#__PURE__*/React.createElement("button", {
      className: "close-campaign",
      onClick: function onClick() {
        return props.show_campaign(false);
      }
    }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null)), /*#__PURE__*/React.createElement("a", {
      href: props.campaign_link,
      target: "_blank"
    }, /*#__PURE__*/React.createElement("img", {
      src: props.button_image,
      className: "campaign-button"
    })), /*#__PURE__*/React.createElement("style", null, "\n          .campaign-button-wrapper {\n            position: fixed;\n            text-align: right;\n            bottom: 60px;\n            padding-right: 10px;\n            z-index: 3;\n            right: 0;\n            transition: all .4s ease-in;\n          }\n\n          .campain-button-wrapper a {\n            display: inline-block;\n          }\n\n          .close-campaign {\n            width: 20px;\n            height: 20px;\n            position: absolute;\n            border-radius: 50%;\n            background-color: ".concat(props.close_bg_color, ";\n            top: 0;\n            right: 10px;\n            border: none;\n          }\n\n          .close-campaign span {\n            width: 10px;\n            height: 1.5px;\n            border-radius: 8px;\n            display: block;\n            background-color: ").concat(props.close_arrow_color, ";\n            position: absolute;\n            top: 47.5%;\n            left: 5px;\n          }\n\n          .close-campaign span:nth-child(1) {\n            transform: rotate(45deg);\n          }\n\n          .close-campaign span:nth-child(2) {\n            transform: rotate(-45deg);\n          }\n\n          .campaign-button {\n            max-width: 100%;\n            display: block;\n            margin-left: auto;\n            width: 80px;\n          }\n        ")));
  };

  var ButtonCampaign = function ButtonCampaign(_ref) {
    var is_mobile = _ref.is_mobile,
        element_id = _ref.element_id,
        campaign_link = _ref.campaign_link,
        button_image = _ref.button_image,
        close_bg_color = _ref.close_bg_color,
        close_arrow_color = _ref.close_arrow_color,
        show_campaign = _ref.show_campaign;
    var props = {
      is_mobile: is_mobile || false,
      element_id: element_id || '',
      campaign_link: campaign_link,
      button_image: button_image,
      close_bg_color: close_bg_color || "transparent",
      close_arrow_color: close_arrow_color || "transparent",
      show_campaign: show_campaign
    };

    if (is_mobile) {
      return /*#__PURE__*/React.createElement(Mobile, props);
    } else {
      return /*#__PURE__*/React.createElement(Desktop, props);
    }
  };

  return ButtonCampaign;

})));
//# sourceMappingURL=button_campaign.umd.js.map
